import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';

import { AbstractListComponent } from '../../../../../shared/crud/component/list.component';
import { Language } from '../../../../../shared/enum/language';
import { BreadcrumbBuilder } from '../../../../../shared/ui/breadcrumb/breadcrumb-builder';
import { Subject } from 'rxjs';
import { IConfirmationDialogPayload } from '../../../../../shared/ui/component/confirmation-dialog/confirmation-dialog-payload.interface';

@Component({
  selector: 'admin-job-list',
  templateUrl: './list.component.html',
  styleUrls: [ './list.component.scss' ]
})
export class AdminJobListComponent extends AbstractListComponent implements OnInit {

  restartJobSubject: Subject<IConfirmationDialogPayload> = new Subject();
  languages: any = Language;
  campaigns: any[] = [];

  getResourceUrl(): string {
    return '/admin/job';
  }

  constructor(httpClient: HttpClient,
              toastrService: ToastrService,
              router: Router,
              route: ActivatedRoute,
              private breadcrumbBuilder: BreadcrumbBuilder) {
    super(httpClient, toastrService, router, route);
  }

  ngOnInit() {
    this.parameters.orderBy = 'id';
    this.parameters.orderDir = 'desc';
    this.parameters.conditions = {
      handler: '',
      status: 'error',
      campaign: ''
    };
    this.breadcrumbBuilder.clear();
    this.breadcrumbBuilder.add({
      label: 'Admin / Jobs',
      url: '/admin/job'
    });

    this.parameters.limit = 50;
    super.ngOnInit();

    this.httpClient.get('/admin/campaign/all').subscribe((data: any) => {
      this.campaigns = data.campaigns;
    }, (err: any) => {
      this.toastrService.error('Could not load campaigns');
    });
  }

  changeStatus() {
    this.load();
  }

  changeCampaign() {
    this.load();
  }

  filterByHandler() {
    this.load();
  }

  restartJob(job): void {
    this.httpClient.put(`/admin/job/${job.id}/restart`, {})
      .subscribe(
        (response: any) => {
          this.restartJobSubject.next(<IConfirmationDialogPayload>{
            result: true,
            message: 'Restarted'
          });
        },
        (error: any) => {
          this.restartJobSubject.next(<IConfirmationDialogPayload>{
            result: false,
            message: 'Unable to restart job'
          });
        }
      );
  }
}
